import { MedicalRecordForm } from 'models/MedicalRecord/MedicalRecordForm.type'
import { apiEndpoints } from 'settings/_apiSettings'
import axios from 'settings/axios'
import { Error } from './error.types'

import { AxiosResponse } from 'axios'
interface MedicalRecordFormResponse<T> extends AxiosResponse {
  form: T;
}

export const getForm = (formUuid: string): Promise<MedicalRecordForm> => {
  const endpoint = apiEndpoints.MEDICAL_RECORDS_GET_FORM(formUuid)
  return new Promise<MedicalRecordForm>((resolve, reject) => {
    axios
      .get<MedicalRecordFormResponse<MedicalRecordForm>>(endpoint)
      .then((response: MedicalRecordFormResponse<MedicalRecordForm>) => resolve(response.form))
      .catch((error: Error) => reject(error?.response?.status))
  })
}

